import { render, staticRenderFns } from "./PagedListMicrositesNoHighlights.vue?vue&type=template&id=8c918e9e&"
import script from "./PagedListMicrositesNoHighlights.vue?vue&type=script&lang=js&"
export * from "./PagedListMicrositesNoHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports